<template>
  <div id="wrapper">
    <Nav :message="message" />
    <VPNList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import VPNList from '@/components/admin/VPNList.vue'

export default {
  name: 'vpn-list',
  props: ['message'],
  components: {
    Nav,
    VPNList
  }
}
</script>